module.exports = "/_next/static/images/c276e7e598ad37700e5f71ba85f2c788-minimo_rotativo.png";